<template>
  <!-- 提现详情页面 -->
  <div class="Recharge" >
    <h2>{{ $t(`pay.withdrawalDetails`) }}</h2>
    <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="top" disabled>
      <el-row>
        <el-col :span="6">
            <el-form-item label="id">
              <el-input   v-model="formInline.id "  ></el-input>
             </el-form-item>
        </el-col>
        <el-col :span="6">
            <el-form-item  :label="$t(`pay.money`)">
              <el-input v-model="formInline.amount" ></el-input>
             </el-form-item>
        </el-col>
        <el-col :span="6">
            <el-form-item :label="$t(`pay.currency`)">
              <el-input v-model="formInline.coin" ></el-input>
             </el-form-item>
        </el-col>
        <el-col :span="6">
            <el-form-item :label="$t(`pay.network`)">
              <el-input v-model="formInline.chain" ></el-input>
             </el-form-item>
        </el-col>
      </el-row>
      <el-row>   
        <el-col :span="6">
            <el-form-item :label="$t(`pay.userEmail`)">
              <el-input v-model="formInline.email " ></el-input>
             </el-form-item>
        </el-col>   
     
      
        <el-col :span="6">
            <el-form-item :label="$t(`pay.applicationTime`)">
              <el-input v-model="formInline.appliedTime" ></el-input>
             </el-form-item>
        </el-col>
          <!-- 当前币种余额 -->
          <el-col :span="6">
            <el-form-item :label="$t(`pay.currencyBalance`)">
              <el-input v-model="formInline.balance" ></el-input>
             </el-form-item>
        </el-col>        
        <el-col :span="6">
            <el-form-item :label="$t(`pay.refund`)">
              <el-input v-model="formInline.refund" ></el-input>
             </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        
        <el-col :span="6">
            <el-form-item :label="$t(`pay.refundTime`)">
              <el-input v-model="formInline.refundTime" ></el-input>
             </el-form-item>
        </el-col>
        <el-col :span="6">
            <el-form-item :label="$t(`pay.refundTxid`)">
              <el-input v-model="formInline.refundTxid" ></el-input>
             </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
            <el-form-item label="备注">
              <el-input   resize="none"
                type="textarea"
                :rows="3" v-model="formInline.message" ></el-input>
             </el-form-item>
        </el-col> -->
      </el-row>
      <el-row>
      <el-col >
            <el-form-item :label="$t(`pay.userAddress`)" style="width: 38%;">
              <el-input v-model="formInline.userAddress " ></el-input>
             </el-form-item>
        </el-col>
    </el-row>
    <el-row>
      <el-col >
            <el-form-item :label="$t(`pay.appliedAddress`)" style="width: 38%;">
              <el-input v-model="formInline.appliedAddress" ></el-input>
             </el-form-item>
        </el-col>
    </el-row>
    <el-row>
      <el-col >
        <el-form-item :label="$t(`pay.Remarks`)"  style="width: 38%;">
              <el-input   resize="none"
                type="textarea"
                :rows="3" v-model="formInline.message" ></el-input>
             </el-form-item>
      </el-col>
      
      
    </el-row>
  
    


</el-form>

  </div>
</template>

<script>
import IndexJs from "./index";
export default {
  mixins: [IndexJs],
};
</script>

<style lang="scss" scoped>

.Recharge{
  width: 80%; 
  height: 100%; 
  //  background: firebrick;
  //  padding: 20px;
   box-sizing: border-box;
   margin: 0 auto;
   padding-top: 50px;
  //  outline: 1px solid red;

  
  .formBox{
    // outline: 1px solid red;
    width: 100%;
  }
  .dialog-footer{
    margin-top: 100px;
    display: flex;
    justify-content: space-evenly;
    box-sizing: border-box;
    padding: 0px 50px;
    // outline: 1px solid red;

  }
 
//  ::v-deep .el-dialog{
//     height: 300px;
//   }
.transferSuccessful{
  
  ::v-deep .el-dialog{
    height: 220px;
  }
}




}

.demo-form-inline{

 ::v-deep .el-input.is-disabled .el-input__inner{
    color: rgba(0,0,0,0.6);
  }

  ::v-deep .el-textarea.is-disabled .el-textarea__inner{
    color: rgba(0,0,0,0.6);
  }


}


</style>
